<script>
import { mapGetters } from 'vuex'
export default
{
    name: 'offer',

    props:
    {
        preview: Boolean,
        poffer: {
            type: Object,
            default: () => {}
        },
    },

    computed: 
    {
        ...mapGetters({ 
            channel: 'channel',
            offers: 'offers',
            visitor: 'visitor',
        }),

        currentOffer()
        {
            if (this.preview)
            {
                return this.poffer
            }
            if (this.user.offer_signups && this.user.offer_signups.length > 0)
            {
                for (let i = 0; i < this.offers.length; ++i)
                {
                    if (this.isOfferFilled(this.offers[i].id))
                        continue
                    return this.offers[i]
                }
                this.$router.replace(process.env.THANKYOU_PAGE)
            }
            return this.offers[0]
        },

        currentOfferNr()
        {
            if (this.currentOffer && this.currentOffer.id)
            {
                for (let i = 0; i < this.offers.length; ++i)
                {
                    if (this.offers[i].id == this.currentOffer.id)
                    {
                        return i + 1;
                    }
                }
            }
            return 1
        },

        user()
        {
            if (this.preview)
                return this.previewData
            return this.visitor.subscription || {}
        },

        image()
        {
            if (this.mobileCheck())
            {
                if (this.currentOffer.mobile_images.length > 0)
                    return this.currentOffer.mobile_images[0].display_url
            } else {
                if (this.currentOffer.desktop_images.length > 0)
                    return this.currentOffer.desktop_images[0].display_url
            }
        },

        activated()
        {
            const modifier = this.$moment().isoWeekday() * 50
            const number = 100 + Math.random() * modifier
            return number.toFixed(0)
        },

        totalOfferCount()
        {
            if (this.preview)
            {
                return this.previewData.totalOffers
            }
            return this.offers.length
        },

        subscriptionFields()
        {
            if (this.user && this.user.fields)
            {
                return this.user.fields || []
            }
            return []
        },

        offerFields()
        {
            if (this.currentOffer && this.currentOffer.fields)
            {
                return this.currentOffer.fields
            }
            return []
        },

        missingFields()
        {
            const missing = []
            for (let i = 0; i < this.offerFields.length; ++i)
            {
                const field = this.offerFields[i]
                const userField = this.subscriptionFields.getBy('name', field.name)
                if (userField.name == field.name) {
                    continue
                } else {
                    missing.push(field)
                }
            }
            return missing
        },
    },

    methods:
    {
        getField(key)
        {
            if (this.preview)
            {
                return this.previewData[key]
            }
            if (this.user && this.user.fields)
            {
                for (let i = 0; i < this.user.fields.length; ++i)
                {
                    const field = this.user.fields[i]
                    if (field.name == key)
                    {
                        return field.pivot.value
                    }
                }
            }
        },

        isOfferFilled(id)
        {
            if (this.user.offer_signups && this.user.offer_signups.length > 0)
            {
                for (let i = 0; i < this.user.offer_signups.length; ++i)
                {
                    const item = this.user.offer_signups[i]
                    if (item.offer_id == id)
                        return true
                }
            }
            return false
        },

        safeGetFirst(arr, key)
        {
            if (this.currentOffer && this.currentOffer[arr] && this.currentOffer[arr].length > 0)
            {
                return this.currentOffer[arr][0][key]
            }
            return null
        },
        
        mobileCheck()
        {
            try {
                document.createEvent('touchEvent')
                return true
            } catch (e) { return false }
            return false
        },

        activate()
        {
            if (!this.preview)
            {
                this.$store.dispatch('activate', { id: this.currentOffer.id, model: this.offerModel }).then(res => {
                    this.$analytics.fbq.event('Activate')
                    this.activate_clicked = true
                    this.activateData = res
                })
            }
        },

        skip()
        {
            if (!this.preview) {
                this.$store.dispatch('skip', { id: this.currentOffer.id, model: {}}).then(res => {
                    this.$analytics.fbq.event('Skip')
                    this.activate_clicked = false
                    this.activateData = {}
                })
            }
        },

        next()
        {
            if (!this.preview)
            {
                this.$analytics.fbq.event('Next')
                this.$store.dispatch('real_activate', this.activateData)
            }
        },

        nextWithLink()
        {
            if (!this.preview)
            {
                this.$store.dispatch('activate', { id: this.currentOffer.id, model: {} }).then(res => {
                    this.$analytics.fbq.event('NextLink')
                    this.$store.dispatch('real_activate', res)
                })
            }
        },

        back()
        {
            window.history.back()
        }
    },

    data()
    {
        return {
            previewData: {
                first_name: 'Visitor',
                remaining_months: 4,
                totalOffers: 3,
                currentOffer: 1,
                hasFields: false,
            },
            offerModel: {},
            activateDate: {},
            activate_clicked: false,
        }

    },
  
}
</script>

<template>
<section v-if="currentOffer && currentOffer.id" class="offer-page">
    <div class="top-bar d-none d-sm-block" v-if="preview">
        <div class="row">
            <div class="col-sm-5">
                <input type="text" class="form-control" v-model="previewData.first_name">
            </div>
            <div class="col-sm-5">
                <input type="number" class="form-control" v-model="previewData.remaining_months">
            </div>
            <div class="col-sm-2 text-right">
                <a href="#" @click="back" class="btn btn-danger">
                    Back
                </a>
            </div>
        </div>
    </div>
    <div class="offer-head offer-head-checklist">
        <logo red></logo>
        <!-- Noti -->
    </div>

    <div class="container-fluid cont-720">
        <p class="offer-top">
            <strong v-if="currentOffer.has_wedding_date && getField('first_name') && user.remaining_months">
                {{ getField('first_name') }}, only {{ user.remaining_months }} months until your wedding!
            </strong>
            <br>
            Check out these {{ totalOfferCount }} special offers just for you.
        </p>

        <div class="offer-mobile-center d-sm-none">
            <span 
                class="line" 
                v-for="(count, index) in totalOfferCount" 
                :key="count" 
                :class="{ 'active': index == count }">
            </span>
        </div>

        <div class="offer-body text-center">
            <div class="offer-sticker offer-counter d-none d-sm-block">
                {{ currentOfferNr }} / {{ totalOfferCount }}
            </div>
            <span 
                class="offer-sticker free-sticker" 
                :style="{ backgroundColor: safeGetFirst('colors', 'color')}"
                v-if="currentOffer.stickers.length > 0">{{ currentOffer.stickers[0].text }}</span>

            <div class="image"></div>
            <img 
                v-if="image"
                :src="image"
                alt="Image"
                >

            <div 
                class="offer-title" 
                v-if="currentOffer.headlines.length > 0" v-html="currentOffer.headlines[0].text"
                :style="{ backgroundColor: safeGetFirst('colors', 'color')}"
                >
                </div>

            <div class="offer-normal" v-if="currentOffer.excerpts.length > 0"><strong>{{ currentOffer.excerpts[0].text }}</strong></div>

            <div class="offer-details text-left">
                <div class="offer-details-head text-uppercase">
                    This offer
                </div>
                <div class="offer-details-body" v-if="currentOffer.bodies.length > 0" v-html="currentOffer.bodies[0].text"></div>
            </div>
        </div>

        <div class="offer-activated text-center">
            <i class="fa fa-check-circle"></i>
            {{ activated }} activated this week
        </div>

        <div class="offer-mobile-foot-block">

            <div class="offer-foot-block-links">

                <template v-if="currentOffer.is_hostnpost">
                    <div class="signup-form-container mt-4 mb-5" v-if="missingFields.length > 0">
                        <div class="signup-form-heading" v-if="!activate_clicked">
                            <div>Please add your details below</div>
                        </div>

                        <div class="inner">
                            <form @submit.prevent.stop="activate">

                                <div class="row inner">
                                    <div class="form-group col-sm-4" v-for="field in missingFields" :key="field.id" v-if="!activate_clicked">
                                        <label class="caps">{{ field.label }}</label>
                                        <input class="form-control" required v-model="offerModel[field.name]" v-if="field.type == 'text'">
                                        <input type="email" class="form-control" required v-model="offerModel[field.name]" v-if="field.type == 'email'">
                                        <input type="date" class="form-control" required v-model="offerModel[field.name]" v-if="field.type == 'date'">
                                        <select v-model="offerModel[field.name]" v-if="field.type == 'select'" class="form-control" required>
                                            <option v-for="value in field.values" :key="value" :value="value">{{ value }}</option>
                                        </select>
                                    </div>
                                </div>

                                <div class="row" v-if="!activate_clicked">
                                    <div class="col">
                                        <button type="submit" class="btn btn-submit text-uppercase btn-full" v-if="currentOffer.label_yes.length > 0">
                                            {{ currentOffer.label_yes[0].text }}
                                        </button>
                                    </div>

                                </div>
                                <div class="next-btn-wrap" v-else>
                                    <div class="row">
                                        <div class="col-sm-7 left-row">
                                            <i class="fa fa-check-circle"></i>
                                            Signed up
                                        </div>
                                        <div class="col-sm-5 text-right">
                                            <button type="submit" class="btn btn-submit text-uppercase btn-full" @click.prevent.stop="next">
                                                Next
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <form method="post" @submit.prevent="activate" v-else>
                        <p class="signup-btn-wrap" v-if="!activate_clicked">
                            <button class="btn btn-submit text-uppercase" v-if="currentOffer.label_yes.length > 0">
                                {{ currentOffer.label_yes[0].text }}
                            </button>
                        </p>
                        <div class="next-btn-wrap" v-else >
                            <div class="row">
                                <div class="col-sm-7 left-row">
                                    <i class="fa fa-check-circle"></i>
                                    Signed up with {{ getField('email') }}
                                </div>
                                <div class="col-sm-5 text-right">
                                    <button class="btn text-uppercase" @click.prevent.stop="next">
                                        Next
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </template>

                <p class="signup-btn-wrap" v-else>
                    <a 
                        class="btn btn-submit text-uppercase" 
                        @click="activate_clicked = true" 
                        v-if="!activate_clicked"
                        :href="currentOffer.referal_url" 
                        :target="currentOffer.is_newtab ? '_blank' : ''">
                        <span v-if="currentOffer.label_yes.length > 0">
                            {{ currentOffer.label_yes[0].text }}
                        </span>
                    </a>

                    <button 
                        class="btn btn-submit text-uppercase" 
                        v-else
                        @click.stop.prevent="activate_clicked = false; nextWithLink()">
                        Next
                    </button>
                </p>
                <p class="offer-skip text-center text-uppercase">
                    <a href="#" class="btn btn-skip" @click.prevent.stop="skip" v-if="currentOffer.label_nos.length > 0">
                        {{ currentOffer.label_nos[0].text }}
                        <i class="fal fa-long-arrow-right"></i>
                    </a>
                </p>
            </div>
        </div>

        <div class="offer-foot text-center" v-if="channel.footer">
            {{ channel.footer }}
        </div>
    </div>
</section>
</template>

<style lang="scss">
.top-bar {
    position: fixed;
    z-index: 9999;
    top: 0;
    right: 0;
    background-color: #000;
    padding: .5em 1.5em;
    border-bottom-left-radius: 10px;
    color: white;
}
</style>




// WEBPACK FOOTER //
// src/components/offers/Offer.vue